import './styles/main.css'
import Fluidvids from 'fluidvids.js'

import navigation from './navigation'
import coeurs from './coeur'
import expand from './expand'
import details from './details'
import addToCart from './add-to-cart'
import popup from './pop-up'
import press from './press'
import countrySelect from './country-select'
import ajaxSection from './ajax-section'
import marquee from './marquee'
import checkboxToggle from './checkbox-toggle'
import floatingButton from './floating-button'

navigation()
coeurs()
expand()
details()
addToCart()
popup()
press()
countrySelect()
ajaxSection()
marquee()
checkboxToggle()
floatingButton()

Fluidvids.init()
